<template>
    <div class="qf-filter-box d-flex flex-column pt-1 text-left">
        <div class="mb-3 px-1 small">
            <input type="text" :placeholder="$ml.get('Search')"
                   v-model="filterByInput" v-on:keyup.enter="submit"/>
                   
        </div>
    </div>
</template>

<script>
    export default {
        name: "TableFilter",
        props: {
            uniqueKey: String
        },
        data() {
            return {
                filterByInput: '',
            }
        },
        mounted() {
            if (this.$route.query.owner && this.uniqueKey == 'Owner') {
                this.filterByInput = this.$route.query.owner
            }
            if (this.$route.query.status && this.uniqueKey == 'Status') {
                this.filterByInput = this.$route.query.status
            }
            if (this.$route.query.country && this.uniqueKey == 'Country') {
                this.filterByInput = this.$route.query.country
            }
            if (this.$route.query.brand && this.uniqueKey == 'Brand') {
                this.filterByInput = this.$route.query.brand
            }
            if (this.$route.query.earlierTrademark && this.uniqueKey == 'EarlierTrademark') {
                this.filterByInput = this.$route.query.earlierTrademark
            }
        },
        methods: {
            submit() {
                this.$emit('changeOfValue', this.filterByInput, this.uniqueKey);
            }
        }
    }
</script>

<style scoped>
    .badge {
        white-space: normal;
    }
</style>
